/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ActivityLog {
    angular.module("meevo.plugins.activityLog", []);
}